module.exports = __webpack_public_path__ + "img/person-digging.c296bc1f.svg";